import { Button, Divider, Grid, Stack, Typography, Alert } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../hooks/NotificationContext';
import { addDataToLocalStorage, resendLinkToUser } from '../../lib/utils';
import { loginUser } from '../../modules/users';
import LoginForm from './LoginForm';
import SocialLogins from './SocialLogins';

const LoginUser = () => {
  const navigate = useNavigate();
  const { addNotification } = useNotification();
  const [userEmail, setUserEmail] = useState('');
  const [showResendLink, setShowResendLink] = useState(false);
  const [supportEmail, setSupportEmail] = useState('');
  const [supportMessage, setSupportMessage] = useState('');

useEffect(() => {
  const token = localStorage.getItem('token');
  if (!token) return;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const isTokenValid = Date.now() < payload.exp * 1000;

    if (isTokenValid) {
      navigate('/dashboard', { replace: true });
    } else {
      localStorage.clear();
    }
  } catch {
    localStorage.clear();
  }
}, [navigate]);


  const handleSubmit = async (values) => {
    try {
      setUserEmail(values.email);
      setSupportEmail('');
      setSupportMessage('');
      const user = {
        email: values.email,
        password: values.password,
        platform: values.platform || 'web',
      };
      const data = await loginUser(user);
      addNotification('success', 'User logged in successfully! Redirecting...');
      addDataToLocalStorage(data);
      localStorage.setItem('isLoggedIn', true);
      navigate('/dashboard', { replace: true });
      // window.location.reload();
    } catch (error) {
      const errorMessage = error.message || 'Login failed. Please try again';
      if (errorMessage.includes('confirm your email')) {
        setShowResendLink(true);
      }

      if (errorMessage.toLowerCase().includes('contact support')) {
        const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;
        const match = errorMessage.match(emailRegex);
        if (match) {
          setSupportEmail(match[0]);
        }
        const cleanedMessage = errorMessage.replace(/<a.*<\/a>/, '').trim();
        setSupportMessage(cleanedMessage);
      } else {
        addNotification('error', errorMessage);
      }
    }
  };

  const handleResendLink = async () => {
    try {
      const response = await resendLinkToUser(userEmail, 'confirmation');
      addNotification('success', response);
    } catch (error) {
      addNotification('error', error.message);
    }
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="baseline">
            <Typography variant="h4">Sign In</Typography>
            <Typography variant="body1" className='subheading-text'>
              Welcome to GAINSS: Manage Your Test Cases with Ease
            </Typography>
          </Stack>
        </Grid>

        {supportMessage && supportEmail && (
          <Grid item xs={12}>
            <Alert severity="error">
              <span
                dangerouslySetInnerHTML={{
                  __html: supportMessage.replace(
                    /support/gi,
                    `<a href="mailto:${supportEmail}" style="text-decoration:underline;color:inherit;"><b>support</b></a>`
                  ),
                }}
              />
            </Alert>
          </Grid>
        )}
        <Grid item xs={12}>
          <LoginForm handleLogin={handleSubmit} />
        </Grid>
        <Grid item xs={12}>
          <Divider>
            <Typography>Or</Typography>
          </Divider>
        </Grid>
        <Grid item xs={12}>
          <SocialLogins handleSubmit={handleSubmit} />
        </Grid>
        {showResendLink && (
          <Grid item xs={12} sx={{ textAlign: 'center', mt: 2 }}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              If you haven't received the confirmation email, click below to
              resend it.
            </Typography>
            <Button variant="outlined" onClick={handleResendLink}>
              Resend Email
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default LoginUser;
